import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as loginReducer from "containers/Login/reducer";

import TenantViewContainer from "containers/View/Tenant";
import AccountViewContainer from "containers/View/Account";
import AdminContainer from "containers/Admin/Admin";
import UserManagementView from "components/Admin/UserManagementView";
import LlmManagementView from "components/Admin/LlmManagementView";

import Analytics from "components/Analytics/Analytics";

import View from "components/View/View";

import { SETTINGS_VIEW_TYPE as VIEW_TYPE } from "containers/View/reducer";

import { isEnabled } from "utils/featureFlags";

class SettingsViewContainer extends React.PureComponent {
  renderType(type) {
    const { isSampleAccount, isEvaluationAccount } = this.props;

    const adminEnabled = isEnabled("admin");

    switch (type) {
      case VIEW_TYPE.ALL:
        return (
          <React.Fragment>
            <TenantViewContainer subViewType={"all"} />
            <AccountViewContainer subViewType={"all"} />
          </React.Fragment>
        );

      case VIEW_TYPE.ORGANIZATIONS:
        return <TenantViewContainer key={type} />;

      case VIEW_TYPE.ACCOUNTS:
        return <AccountViewContainer key={type} />;

      case VIEW_TYPE.ADMIN:
        if (adminEnabled) {
          return <AdminContainer />;
        }
        break;

      case VIEW_TYPE.USER_MANAGEMENT:
        if (adminEnabled && isEnabled("user-management-settings")) {
          return <UserManagementView />;
        }
        break;

      case VIEW_TYPE.LLM_MANAGEMENT:
        if (adminEnabled && isEnabled("llm-provisioning-settings")) {
          return <LlmManagementView />;
        }
        break;

      case VIEW_TYPE.ANALYTICS:
        if (isEnabled("user-activity-analytics")) {
          return <Analytics />;
        }
        break;

      default:
        return <div key={type} />;
    }
    return <div key={type} />;
  }

  render() {
    const { type, updateType, updateSearch, typeOptions, search } = this.props;

    return (
      <View
        type={type}
        updateType={updateType}
        typeOptions={typeOptions}
        isSettingsView
        hideTileToggle
        search={search}
        updateSearch={
          type !== VIEW_TYPE.ADMIN && type !== VIEW_TYPE.USER_MANAGEMENT && type !== VIEW_TYPE.LLM_MANAGEMENT
            ? (v) => updateSearch(v)
            : undefined
        }
      >
        {this.renderType(type)}
      </View>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateType: (type) => dispatch(viewReducer.updateSettingsType(type)),
  updateSearch: (search) => dispatch(viewReducer.updateSettingsSearch(search))
});

const mapStateToProps = (state, ownProps) => ({
  typeOptions: viewReducer.getViewTypeOptions(state),
  type: viewReducer.getSettingsType(state),
  isSampleAccount: loginReducer.getIsSampleAccount(state),
  isEvaluationAccount: loginReducer.getIsEvaluationAccount(state),
  search: viewReducer.getSettingsSearch(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SettingsViewContainer);
